import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit'
import { UIInput, UIDropdown, UIDatePickerInput } from './../../../../components/forms/form-fields'
import moment from 'moment'
import { toast } from 'react-toastify'
import Store from './../../store'
import { teamLogoImage } from './../../helpers/teamLogoImage.function'
import UploadEliteAgencyTeamLogoButton from './../UploadEliteAgencyTeamLogoButton/UploadEliteAgencyTeamLogoButton.component'

import './EliteAgencyTeamForm.scss'

const toDate = dateStr => {
  if (dateStr) {
    if (typeof dateStr === 'string') return moment(`${dateStr}`.split('T').shift()).toDate()
    if (typeof dateStr === 'object') return dateStr
  }
}

const EliteAgencyTeamForm = ({ EliteAgencyTeam }) => {
  const isNew = !!EliteAgencyTeam?.isNew(),
    [isSaving, setIsSaving] = useState(false),
    [showValidity, setShowValidity] = useState(false)

  const onDateChange = (field, value) => {
    if (value) {
      const isValidDate = value instanceof Date && !isNaN(value.getTime())
      if (isValidDate) {
        const valueStr = JSON.parse(JSON.stringify(value)).split('T').shift()
        EliteAgencyTeam.set(field, valueStr)
      }
    } else {
      EliteAgencyTeam.set(field, null)
    }
  }

  const handleSubmit = async evt => {
    if (evt.preventDefault) evt.preventDefault()

    if (!Store.isValid(EliteAgencyTeam)) {
      if (!showValidity) setShowValidity(true)
      return false
    }

    if (showValidity) setShowValidity(false)
    setIsSaving(true)

    try {
      await EliteAgencyTeam.save()
      toast.success('Elite Agency Team saved successfully', {
        position: toast.POSITION.TOP_RIGHT,
      })
      setIsSaving(false)
      return true
    } catch (ex) {
      toast.error('Failed to save Elite Agency Team', {
        position: toast.POSITION.TOP_RIGHT,
      })
      setIsSaving(false)
      return false
    }
  }

  return (
    <form
      className={`content-wrapper container-fluid mb-4 EliteAgencyTeamFormComponent ${
        isNew ? 'create-elite-agency-team' : 'update-elite-agency-team'
      }`}
      noValidate
      onSubmit={evt => handleSubmit(evt)}
    >
      {isNew ? (
        <div className='row is-new-team'>
          <div className='col'>
            <h6>NEW ELITE AGENCY TEAM</h6>
            <span>Complete & Save</span>
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className='row'>
        <div className='col'>
          <div className='mb-3'>{teamLogoImage(EliteAgencyTeam)}</div>
          <UploadEliteAgencyTeamLogoButton
            EliteAgencyTeam={EliteAgencyTeam}
            block
            size='sm'
            type='button'
            disabled={Store.isFetching || isSaving}
            label={
              <>
                Upload Elite Agency Team Logo &nbsp;
                <MDBIcon icon='cloud-upload-alt' />
              </>
            }
          />
        </div>
        <div className='col'>
          <div>
            <UIInput
              label='Elite Agency Team Name'
              name='team_name'
              value={EliteAgencyTeam?.get('team_name') || ''}
              onChange={evt => {
                if (EliteAgencyTeam) EliteAgencyTeam.set('team_name', evt.target.value)
              }}
            />
          </div>
          <div>
            <UIDropdown
              label='Elite Agency Team Leader'
              name='owner_id'
              options={Store.Agents.map(Agent => ({
                text: `${Agent.get('u_fname')} ${Agent.get('u_lname')}`.trim(),
                value: `${Agent.id()}`,
                checked: `${Agent.id()}` === `${EliteAgencyTeam?.get('owner_id')}`,
              }))}
              onChange={evt => {
                if (`${evt.target.value}` !== `${EliteAgencyTeam?.get('owner_id')}` && evt.target.value)
                  EliteAgencyTeam.set('owner_id', evt.target.value)
              }}
              required={true}
              value={EliteAgencyTeam.get('owner_id')}
              rules={{ required: true }}
              showValidity={showValidity}
              onValidityChange={validity => {
                /* SalesTrackerStore.setValidity(idx, 'av_term_length', validity.isValid) */
              }}
            />
          </div>
          <div>
            <UIDatePickerInput
              label='Team Created At'
              name='team_created_at'
              onChange={evt => onDateChange('team_created_at', evt.target.value)}
              required={true}
              autoComplete='off'
              showYearDropdown
              yearDropdownItemNumber={5}
              scrollableYearDropdown
              dateFormat='MM/dd/yyyy'
              selected={toDate(EliteAgencyTeam?.get('team_created_at'))}
              value={
                EliteAgencyTeam?.get('team_created_at')
                  ? moment(toDate(EliteAgencyTeam.get('team_created_at'))).format('MM/DD/YYYY')
                  : null
              }
              rules={{ required: true }}
              showValidity={showValidity}
            />
          </div>
          <div>
            <UIDatePickerInput
              label='Team Dissolved At'
              name='team_dissolved_at'
              onChange={evt => onDateChange('team_dissolved_at', evt.target.value)}
              autoComplete='off'
              showYearDropdown
              yearDropdownItemNumber={5}
              scrollableYearDropdown
              dateFormat='MM/dd/yyyy'
              isClearable
              selected={toDate(EliteAgencyTeam?.get('team_dissolved_at'))}
              value={
                EliteAgencyTeam?.get('team_dissolved_at')
                  ? moment(toDate(EliteAgencyTeam.get('team_dissolved_at'))).format('MM/DD/YYYY')
                  : null
              }
              showValidity={showValidity}
            />
          </div>
          <div>
            <MDBBtn color='default' block type='submit' disabled={Store.isFetching || isSaving}>
              {EliteAgencyTeam?.isNew() ? 'Save' : 'Update'} Elite Agency Team &nbsp;
              <MDBIcon icon='save' />
            </MDBBtn>
          </div>
        </div>
      </div>
    </form>
  )
}

export default observer(EliteAgencyTeamForm)
